<script>
export default {
  name: 'BaseTableCell',
  props: {
    value: [String, Number],
    optional: [String, Number],
    color: String,
    isBold: Boolean,
    isLarge: Boolean,
    isRow: Boolean,
  },
};
</script>

<template lang="pug">
  .display(:class="{ 'display-row': isRow }" :style="`color: ${color}`")
    .value(:class="{ bold: isBold, large: isLarge }") {{ value }}
    .optional(v-if="optional") {{ optional }}
</template>

<style scoped lang="scss">
.display {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.display-row {
  flex-direction: row;
  gap: 10px;
}
.value {
  display: flex;
  justify-content: center;
}
.bold {
  font-weight: 700;
}
.large {
  font-size: 24px;
}
.optional {
  color: rgba(136, 154, 173, 1);
  font-family: Geometria,serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0.01em;
  text-align: left;

}
</style>
